import { render, staticRenderFns } from "./archivioPEFCGruppo.html?vue&type=template&id=7dcc911d&scoped=true&external"
import script from "./ArchivioPEFCGruppo.vue?vue&type=script&lang=js"
export * from "./ArchivioPEFCGruppo.vue?vue&type=script&lang=js"
import style0 from "./ArchivioPEFCGruppo.vue?vue&type=style&index=0&id=7dcc911d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc911d",
  null
  
)

export default component.exports